<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.auName" style="width: 130px" size="small"
                        placeholder="请输入姓名"></el-input>
                    <el-input v-model="formDatas.auIdcard" style="width: 130px" size="small"
                        placeholder="请输入身份证号"></el-input>
                    <el-select v-model="formDatas.aitsStatus" clearable placeholder="请选择是否参加" @change="partserch"
                        size="small" style="width: 130px">
                        <el-option label="是" value="是" key="1"></el-option>
                        <el-option label="否" value="否" key="2"></el-option>
                    </el-select>
                    <el-select size="small" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                        v-if="post == 2" style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="warning" size="small" style="margin-right: 10px;"
                        @click="DownTwo">新员工培训签到二维码</el-button>
                        <el-button type="primary" size="small" style="margin-left: 10px"
                        @click="batchWord">新员工培训签到表</el-button>    
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增配件分类</el-button> -->

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="aitsId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑设备申请记录' : '新增申请记录'"
                :before-close="handleClose" :visible.sync="dialog" direction="rtl" custom-class="demo-drawer"
                ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="领用日期" prop="aubaBorrowDate">
                                <el-date-picker v-model="form.aubaBorrowDate" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="类型" prop="aubaBorrowType">
                                <el-select v-model="form.aubaBorrowType" clearable placeholder="请选择"
                                    style="width: 130px">
                                    <el-option label="领用" :value="1" key="1"></el-option>
                                    <el-option label="借用" :value="2" key="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="计划规划日期" prop="aubaReturnPlanDate">
                                <el-date-picker v-model="form.aubaReturnPlanDate" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="备注" prop="aubaThisDes">
                                <el-input v-model="form.aubaThisDes" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="资产图片" prop="aubaImages">
                                <my-upload ref="Imgupload" @fileChange="fileChange" :filearr="fileList" :limit="5"
                                    @removeAfter="removeAfter" style="margin: 10px 5px 5px;">
                                </my-upload>

                                <!-- <el-input v-model="form.aaFiles" style="width: 80%;" disabled placeholder="请先上传"></el-input> -->
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 详情 -->
            <el-dialog title="详情" :visible.sync="IsDetail" width="70%" top="8vh">
                <div style="max-height: 700px; overflow-y: scroll">
                    <el-descriptions :column="3" border :labelStyle="{
                        color: '#409EFF',
                        textAlign: 'center',
                        width: '14%',
                        fontSize: '12px'
                    }" :contentStyle="{ textAlign: 'center', width: '18%', fontSize: '12px' }">
                        <el-descriptions-item label="领用日期">{{ DetailArr.aubaBorrowDate }}</el-descriptions-item>
                        <el-descriptions-item label="类型">
                            <el-tag size="small">{{ DetailArr.aubaBorrowType == 1 ? '领用' : '借用' }}</el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="物品类型">
                            <el-tag size="small">{{ DetailArr.aubaType == 1 ? '资产' : DetailArr.aubaType == 2 ? '配件' :
                                DetailArr.aubaType == 3 ? '耗材' : '手机卡' }}</el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="此次物品">{{ DetailArr.aubaThisName }}</el-descriptions-item>
                        <el-descriptions-item label="数量">{{ DetailArr.aubaThisNum }}</el-descriptions-item>
                        <el-descriptions-item label="计划归还时间">{{ DetailArr.aubaReturnPlanDate }}</el-descriptions-item>
                        <el-descriptions-item label="备注">{{ DetailArr.aubaThisDes }}</el-descriptions-item>
                        <el-descriptions-item label="资产图片">
                            <el-image ref="scrImg" id="scrimg" :src="DetailArr.aubaImages.split(',')[0]" alt=""
                                fit="fill" style="width: 50px;height: 50px;"
                                :previewSrcList="DetailArr.aubaImages.split(',')"
                                v-if="DetailArr.aubaImages"></el-image>
                        </el-descriptions-item>
                        <el-descriptions-item label="签名图片">
                            <el-image ref="scrImg" id="scrimg" :src="DetailArr.aubaSign" alt="" fit="fill"
                                style="width: 50px;height: 50px;" :previewSrcList="[DetailArr.aubaSign]"
                                v-if="DetailArr.aubaSign"></el-image>
                        </el-descriptions-item>
                        <el-descriptions-item label="完整图片">
                            <el-image ref="scrImg" id="scrimg" :src="DetailArr.aubaSignScreenshot" alt="" fit="fill"
                                style="width: 50px;height: 50px;" :previewSrcList="[DetailArr.aubaSignScreenshot]"
                                v-if="DetailArr.aubaSignScreenshot"></el-image>
                        </el-descriptions-item>

                    </el-descriptions>


                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
let Base64 = require('js-base64').Base64
var FileSaver = require('file-saver');
import {exportAjInductionTrainingSignWord, updateAjUserBorrowApplyReturn, getAjInductionTrainingSignList, updateAjUserBorrowApplyCheck, updateAjUserBorrowApply, deleteAjInductionTrainingSign, updateAjAssetsHitch, getAjUserBorrowApplyDetails } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            userid:'',
            DetailArr: [],
            IsDetail: false,//详情
            fileList: [],
            BreakDown: false,//处理故障
            dialog: false,
            edit: false,
            form: {
                aitsId: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {

                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 20,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "auName",
                    key: "auName",
                    title: "用户",
                    fixed: 'left',
                    align: "center",
                    width: 80,
                    fixed: 'left',

                },
                {
                    field: "aitsStatus",
                    key: "aitsStatus",
                    title: "是否参加",
                    align: "center",
                    width: 80,

                },

                {
                    field: "aitsTheme",
                    key: "aitsTheme",
                    title: "培训主题",
                    align: "center",
                    width: 150,
                },

                {
                    field: "aitsAddress",
                    key: "aitsAddress",
                    title: "培训地点",
                    align: "center",
                    width: 120,
                },
                {
                    field: "aitsDate",
                    key: "aitsDate",
                    title: "培训日期",
                    align: "center",
                    width: 150,
                    // fixed:'left',

                },
                {
                    field: "auPost",
                    key: "auPost",
                    title: "岗位",
                    align: "center",
                    width: 120,
                },
                {
                    field: "auIdcard",
                    key: "auIdcard",
                    title: "身份证号",
                    align: "center",
                    width: 180,
                },

                {
                    field: "aitsSign",
                    key: "aitsSign",
                    title: "签名图片",
                    align: "center",
                    width: 120,
                    // fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aitsSign ? <el-image ref="scrImg" id="scrimg" src={row.aitsSign} alt="" fit="fill" style="width: 50px;height: 50px;"
                                        previewSrcList={[row.aitsSign]}></el-image> : <span></span>
                                }


                            </span>
                        );
                    },

                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                               {
                                    this.userid == 21 ||  this.userid == 1 ? <el-button

                                        size="mini"
                                        type="text"
                                        on-click={() => this.handleDelete(row)}
                                    >
                                        删除
                                    </el-button> : <span></span>
                                }

                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                auId: '',
                auName: '',
                aubaThisName: '',
                aaId: '',
                aubaType: '',

                aubaBorrowApply: '',
                aubaStatus: '',
                aubaBorrowDateStart: '',
                aubaBorrowDateEnd: '',
                currentPage: 1,
                pageSize: 20,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
         this.userid = localStorage.getItem("userid");
        this.getList();
    },
    mounted() { },
    methods: {
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
        },
        batchWord() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: "danger",
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                console.log("开始导出", this.selectedRowKeysCollection);
                this.openLoading();
                exportAjInductionTrainingSignWord({
                    aitsIds: this.selectedRowKeysCollection.toString(),
                }).then((res) => {
                    if (res.status == 200) {
                        this.loadings.close();
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: "导出成功",
                        });
                        this.checkboxOption.selectedRowKeys =
                            this.selectedRowKeysCollection = [];
                    }
                });
            }
        },
        DownTwo() {
            FileSaver.saveAs('https://txcloud.aojuai.com/icon/ajtools/tools/newygqd.png', '新员工培训签到二维码.png')
        },
        handleReturn(row) {
            this.$confirm("是否确定要归还吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjUserBorrowApplyReturn({ aitsId: row.aitsId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "归还成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        /* 详情 */
        getDetail(id) {
            getAjUserBorrowApplyDetails({ aitsId: id }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
                console.log(this.DetailArr);
            })
        },
        handleCheck(row) {
            this.$prompt("请输入审核备注?", "确定要审核通过吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    console.log(value)
                    updateAjUserBorrowApplyCheck({ aitsId: row.aitsId, aubaStatus: 2, aubaCheckDes: value.value }).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });

                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleRefuseCheck(row) {
            this.$prompt("请输入审核备注?", "确定要拒绝通过吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    updateAjUserBorrowApplyCheck({ aitsId: row.aitsId, aubaStatus: 3, aubaCheckDes: value.value }).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });

                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        removeAfter(file) {
            const url = this.form.aubaImages.findIndex(item => item === file)
            this.form.aubaImages.splice(url, 1)
        },
        // 上传图片
        fileChange(file) {
            console.log(this.form.aubaImages, file);
            if (this.form.aubaImages.length > 0 && this.form.aubaImages != '') {
                this.form.aubaImages.push(...file)
            } else {
                this.$set(this.form, 'aubaImages', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        // 处理故障
        CloseBreakDown() {
            this.BreakDown = false;

            this.$refs['formRef'].resetFields();
        },
        sureBreakDown() {
            this.$confirm("是否确定要处理故障吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjAssetsHitch(this.form).then(res => {
                        if (res.data) {
                            this.CloseBreakDown();
                            this.getList()
                            this.$message({
                                type: "success",
                                message: "处理成功!",
                            });
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })

        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjInductionTrainingSign({ aitsId: row.aitsId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                this.form.aubaImages = data.aubaImages.split(',')
                console.log(this.form.aubaImages);
                if (this.form.aubaImages.length > 0 && this.form.aubaImages != '') {
                    this.form.aubaImages.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList, index, img)
                    })
                }
            })

        },
        SureBtn() {
            if (!this.edit) {

            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        var newForm = JSON.parse(JSON.stringify(this.form));
                        console.log(newForm)
                        newForm.aubaImages = newForm.aubaImages.length > 0 ? newForm.aubaImages.filter(item => typeof item === 'string').join(',') : '';
                        updateAjUserBorrowApply(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.fileList = []
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {

            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.aitsId = row.aitsId
                    console.log(jsonObj);
                    updateAjUserBorrowApply(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys() {
            console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item.aitsId) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item.aitsId);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys) {
            console.log(isSelected, selectedRowKeys);
            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item.aitsId) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item.aitsId), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected) {
            const rowKey = row.aitsId;

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjInductionTrainingSignList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjInductionTrainingSignList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjInductionTrainingSignList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>